<template>
    <div class="container mx-auto bg-white flex justify-between items-center w-full h-full text-xl font-light text-grey-darkest">
        <img class="rounded-full h-12 w-12 border-2 p-0.5 border-grey-light mr-4" :src="profile.picture"/>

        <div class="flex-1 flex flex-col justify-center items-start">
            <span>{{ profile.name }}</span>
            <span class="text-sm text-grey-dark">{{ profile.email }}</span>
        </div>

        <a class="block h-6 w-6 cursor-pointer" :title="__('Logout')" @click="logout">
            <svg class="fill-current h-6 w-6 text-grey hover:text-grey-dark" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" xml:space="preserve">
                <path d="M12,3L12,3c-0.55,0-1,0.45-1,1v8c0,0.55,0.45,1,1,1h0c0.55,0,1-0.45,1-1V4C13,3.45,12.55,3,12,3z M17.14,5.86L17.14,5.86
                c-0.39,0.39-0.38,1-0.01,1.39c1.13,1.2,1.83,2.8,1.87,4.57c0.09,3.83-3.08,7.13-6.91,7.17C8.18,19.05,5,15.9,5,12
                c0-1.84,0.71-3.51,1.87-4.76c0.37-0.39,0.37-1-0.01-1.38l0,0c-0.4-0.4-1.05-0.39-1.43,0.02C3.98,7.42,3.07,9.47,3,11.74
                c-0.14,4.88,3.83,9.1,8.71,9.25c5.1,0.16,9.29-3.93,9.29-9c0-2.37-0.92-4.51-2.42-6.11C18.2,5.47,17.54,5.46,17.14,5.86z"/>
            </svg>
        </a>
    </div>
</template>

<script>
    export default {
        props: {
            profile: {
                type: Object,
                required: true
            },

            logout: {
                type: Function,
                required: true
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/UserBox.vue